export { Skeleton } from './Skeleton';
export type { SkeletonProps } from './Skeleton';

